import BaseList from 'records/BaseList';
import Recipe, { Recipes } from 'records/Recipe';
import { List } from 'immutable';

import {
  RECIPES_ASYNC_ACTION_START,
  RECIPES_ASYNC_ACTION_ERROR,
  RECIPES_ASYNC_COUNT_ACTION_SUCCESS,
  RECIPES_ASYNC_UPDATE_ACTION_SUCCESS,
  RECIPES_CATEGORY_ASYNC_UPDATE_ACTION_SUCCESS,
  RECIPES_ASYNC_DUPLICATE_ACTION_SUCCESS,
  RECIPES_SET_DUP_RECIPEID,
  RECIPES_RESET_STATE,
  RECIPES_UPDATE_SUCCESS,
} from 'actions/recipes';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [RECIPES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RECIPES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RECIPES_ASYNC_COUNT_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [RECIPES_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const recipesData = Recipes(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: recipesData,
    });
  },
  [RECIPES_CATEGORY_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const recipesData = action.data;
    // const newRecipesData = Recipe.mergeRecipesById(state.data, recipesData);
    const newRecipesData = Recipe.mergeRecipesCategoryByCategoryId(state.data, recipesData, action.userCategoryId);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newRecipesData,
    });
  },
  [RECIPES_ASYNC_DUPLICATE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [RECIPES_SET_DUP_RECIPEID]: (state, action) => {
    return state.merge({
      sortKey: action.data,
    });
  },
  [RECIPES_UPDATE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [RECIPES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function recipes(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
